import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-e20e6942"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0,
  class: "log-empty"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "log-empty__text"
}, "暂无变更记录", -1));
const _hoisted_3 = {
  class: "log-head"
};
const _hoisted_4 = {
  class: "log-time"
};
const _hoisted_5 = {
  class: "log-operator"
};
const _hoisted_6 = {
  key: 0,
  class: "log-diff"
};
const _hoisted_7 = {
  class: "diff-name"
};
const _hoisted_8 = {
  class: "diff-val diff-val--old"
};
const _hoisted_9 = {
  class: "diff-val__text"
};
const _hoisted_10 = {
  class: "diff-val diff-val--new"
};
const _hoisted_11 = {
  class: "diff-val__text"
};
const _hoisted_12 = {
  key: 2,
  class: "log-pager"
};
import { computed, ref, watch } from 'vue';
import { ArrowRightOutlined, InboxOutlined } from '@ant-design/icons-vue';
import { OK } from '@/common';
import { getSettingParamLogs } from '@/api/paramSettingApi';
import CopyButton from './CopyButton.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'ParamLogModal',
  props: {
    visible: {
      type: Boolean
    },
    param: null
  },
  emits: ["update:visible"],
  setup(__props, {
    emit
  }) {
    const props = __props;
    /**
     * 参数变更日志弹窗
     * - 打开时按 paramId 拉日志（create_time DESC，后端默认排序）
     * - 用 timeline 展示，每条含操作类型 / 时间 / 操作人 / 字段 diff 列表
     * - 分页：默认 20 条/页，超过 20 才显示分页器
     */
    const open = computed({
      get: () => props.visible,
      set: v => emit('update:visible', v)
    });
    /** 预解析后的日志条目（diffDtoList 已从 JSON 字符串转为数组） */
    const loading = ref(false);
    const logs = ref([]);
    const total = ref(0);
    const page = ref(1);
    const pageSize = 20;
    const isOk = code => String(code) === OK;
    /** diffDtoList 是 JSON 字符串，解析失败时返回空数组 */
    const parseDiff = raw => {
      if (!raw) return [];
      try {
        const arr = JSON.parse(raw);
        return Array.isArray(arr) ? arr : [];
      } catch {
        return [];
      }
    };
    const loadLogs = async () => {
      if (!props.param) return;
      loading.value = true;
      try {
        const res = await getSettingParamLogs({
          paramId: String(props.param.id),
          pageNum: page.value,
          pageSize
        });
        if (isOk(res === null || res === void 0 ? void 0 : res.code)) {
          logs.value = (Array.isArray(res === null || res === void 0 ? void 0 : res.data) ? res.data : []).map(item => ({
            ...item,
            diffs: parseDiff(item.diffDtoList)
          }));
          total.value = (res === null || res === void 0 ? void 0 : res.count) || 0;
        } else {
          logs.value = [];
          total.value = 0;
        }
      } catch (e) {
        console.error('加载参数变更日志失败', e);
        logs.value = [];
        total.value = 0;
      } finally {
        loading.value = false;
      }
    };
    // 弹窗打开 + 有 param 时拉日志；关闭时重置分页
    watch(() => props.visible, v => {
      if (v && props.param) {
        page.value = 1;
        loadLogs();
      } else if (!v) {
        logs.value = [];
        total.value = 0;
      }
    });
    // ===== 展示映射 =====
    const CHANGE_TYPE_LABEL = {
      NEW: '新增',
      ADD: '新增',
      MODIFY: '修改',
      DELETE: '删除'
    };
    const changeTypeLabel = t => CHANGE_TYPE_LABEL[t] || t || '-';
    const CHANGE_TYPE_COLOR = {
      NEW: 'green',
      ADD: 'green',
      MODIFY: 'blue',
      DELETE: 'red'
    };
    const changeTypeColor = t => CHANGE_TYPE_COLOR[t] || 'gray';
    const CHANGE_TYPE_CLASS = {
      NEW: 'tag-add',
      ADD: 'tag-add',
      MODIFY: 'tag-modify',
      DELETE: 'tag-delete'
    };
    const changeTypeClass = t => CHANGE_TYPE_CLASS[t] || 'tag-default';
    /** 后端字段名 → 中文展示 */
    const FIELD_LABEL = {
      paramName: '名称',
      name: '名称',
      paramCode: '编码',
      code: '编码',
      paramSource: '来源',
      source: '来源',
      paramValueType: '值类型',
      paramValue: '参数值',
      value: '参数值',
      remark: '备注'
    };
    const fieldLabel = name => FIELD_LABEL[name] || name;
    return (_ctx, _cache) => {
      const _component_a_timeline_item = _resolveComponent("a-timeline-item");
      const _component_a_timeline = _resolveComponent("a-timeline");
      const _component_a_pagination = _resolveComponent("a-pagination");
      const _component_a_spin = _resolveComponent("a-spin");
      const _component_a_drawer = _resolveComponent("a-drawer");
      return _openBlock(), _createBlock(_component_a_drawer, {
        open: _unref(open),
        "onUpdate:open": _cache[1] || (_cache[1] = $event => _isRef(open) ? open.value = $event : null),
        title: `变更日志${__props.param ? '「' + (__props.param.paramName || __props.param.paramCode || '') + '」' : ''}`,
        width: 860,
        placement: "right",
        "mask-closable": true,
        "destroy-on-close": ""
      }, {
        default: _withCtx(() => [_createVNode(_component_a_spin, {
          spinning: loading.value
        }, {
          default: _withCtx(() => [!loading.value && !logs.value.length ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_unref(InboxOutlined), {
            class: "log-empty__icon"
          }), _hoisted_2])) : (_openBlock(), _createBlock(_component_a_timeline, {
            key: 1,
            class: "log-timeline"
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(logs.value, item => {
              return _openBlock(), _createBlock(_component_a_timeline_item, {
                key: item.id,
                color: changeTypeColor(item.msg)
              }, {
                default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createElementVNode("span", {
                  class: _normalizeClass(["log-tag", changeTypeClass(item.msg)])
                }, _toDisplayString(changeTypeLabel(item.msg)), 3), _createElementVNode("span", _hoisted_4, _toDisplayString(item.createDate || '-'), 1), _createElementVNode("span", _hoisted_5, _toDisplayString(item.creator || '-'), 1)]), item.diffs.length ? (_openBlock(), _createElementBlock("div", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.diffs, (d, idx) => {
                  var _d$oldValue, _d$newValue;
                  return _openBlock(), _createElementBlock("div", {
                    key: idx,
                    class: "diff-row"
                  }, [_createElementVNode("span", _hoisted_7, _toDisplayString(fieldLabel(d.name)), 1), _createElementVNode("div", _hoisted_8, [_createElementVNode("span", _hoisted_9, _toDisplayString((_d$oldValue = d.oldValue) !== null && _d$oldValue !== void 0 ? _d$oldValue : '空'), 1), d.oldValue ? (_openBlock(), _createBlock(CopyButton, {
                    key: 0,
                    text: d.oldValue,
                    label: "修改前"
                  }, null, 8, ["text"])) : _createCommentVNode("", true)]), _createVNode(_unref(ArrowRightOutlined), {
                    class: "diff-arrow"
                  }), _createElementVNode("div", _hoisted_10, [_createElementVNode("span", _hoisted_11, _toDisplayString((_d$newValue = d.newValue) !== null && _d$newValue !== void 0 ? _d$newValue : '空'), 1), d.newValue ? (_openBlock(), _createBlock(CopyButton, {
                    key: 0,
                    text: d.newValue,
                    label: "修改后"
                  }, null, 8, ["text"])) : _createCommentVNode("", true)])]);
                }), 128))])) : _createCommentVNode("", true)]),
                _: 2
              }, 1032, ["color"]);
            }), 128))]),
            _: 1
          })), total.value > pageSize ? (_openBlock(), _createElementBlock("div", _hoisted_12, [_createVNode(_component_a_pagination, {
            current: page.value,
            "onUpdate:current": _cache[0] || (_cache[0] = $event => page.value = $event),
            total: total.value,
            "page-size": pageSize,
            size: "small",
            "show-size-changer": false,
            onChange: loadLogs
          }, null, 8, ["current", "total"])])) : _createCommentVNode("", true)]),
          _: 1
        }, 8, ["spinning"])]),
        _: 1
      }, 8, ["open", "title"]);
    };
  }
});